/**
 * Fase 4a: contratación hasta CONTRACT_GENERATED.
 * Los nombres de paso salen de la guía de backend.
 */

export const PHASE4_BACKEND_PHASE = 'PHASE_4_CONTRACTING';

export const PHASE4_BACKEND_STEPS = Object.freeze({
  OFFER_ACCEPTED: 'OFFER_ACCEPTED',
  CLABE_VALIDATED: 'CLABE_VALIDATED',
  BIOMETRIC_FINAL: 'BIOMETRIC_FINAL',
  PENDING_OPERATIONAL_WINDOW: 'PENDING_OPERATIONAL_WINDOW',
  CONTRACT_GENERATED: 'CONTRACT_GENERATED',
});

export const PHASE4_ERROR_CODES = Object.freeze({
  OFFER_EXPIRED: 'OFFER_EXPIRED',
  OFFER_AMOUNT_MISMATCH: 'OFFER_AMOUNT_MISMATCH',
  OFFER_TERM_MISMATCH: 'OFFER_TERM_MISMATCH',
  OFFER_NOT_AVAILABLE: 'OFFER_NOT_AVAILABLE',
  CLABE_INVALID: 'CLABE_INVALID',
  CLABE_NOT_VALIDATED: 'CLABE_NOT_VALIDATED',
  REJECTED: 'REJECTED',
  UNAVAILABLE: 'UNAVAILABLE',
  BIOMETRIC_FINAL_REQUIRED: 'BIOMETRIC_FINAL_REQUIRED',
  CONTRACT_ALREADY_GENERATED: 'CONTRACT_ALREADY_GENERATED',
  CONTRACT_GENERATION_FAILED: 'CONTRACT_GENERATION_FAILED',
  CONTRACT_NOT_GENERATED: 'CONTRACT_NOT_GENERATED',
  DOCUMENT_TYPE_INVALID: 'DOCUMENT_TYPE_INVALID',
  PHASE_3_NOT_CLOSED: 'PHASE_3_NOT_CLOSED',
});

export const CLABE_STATUS = Object.freeze({
  PENDING: 'PENDING',
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED',
  UNAVAILABLE: 'UNAVAILABLE',
});

/** Códigos del proveedor bancario. 0 es un resultado válido. */
export const CLABE_PROVIDER_CODE = Object.freeze({
  VALID_NAME_MATCH: 0,
  VALID_NAME_UNAVAILABLE: 1,
  ACCOUNT_NOT_FOUND: 2,
  NAME_MISMATCH: 3,
  DEPOSIT_RETURNED: 4,
  UNAVAILABLE: 100,
});

/** Tipos de documento del contrato. Se piden de uno en uno. */
export const CONTRACT_DOCUMENT_TYPES = Object.freeze([
  { tipo: '01', literalKey: 'mutualContract' },
  { tipo: '03', literalKey: 'borrowerLetter' },
  { tipo: '11', literalKey: 'paymentSchedule' },
  { tipo: '26', literalKey: 'promissoryNote' },
]);

/**
 * PDF de simulación, antes de que exista el contrato.
 * El tipo vacío es Cláusulas. El 11 es el PDF complementario;
 * el calendario en pantalla sale de paymentSchedule.
 * El mutuo (01) no se pide aquí.
 */
export const SIMULATION_DOCUMENT_TYPES = Object.freeze([
  { id: 'clauses', tipo: '', literalKey: 'contractClauses' },
  { id: 'financial-run', tipo: '11', literalKey: 'financialRun' },
  { id: 'promissory-note', tipo: '26', literalKey: 'promissoryNote' },
  { id: 'borrower-letter', tipo: '03', literalKey: 'borrowerLetter' },
]);

export const CLABE_LENGTH = 18;
